var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopping = function SvgShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.166 7a1.61 1.61 0 0 0-1.592-1.667h-1.533a.21.21 0 0 1-.208-.208V4.5a2.5 2.5 0 0 0-2.5-2.5h-2.5a2.5 2.5 0 0 0-2.5 2.5v.625a.21.21 0 0 1-.208.208H8.458a.21.21 0 0 1-.208-.208V4.5a.833.833 0 0 1 .833-.833.833.833 0 1 0 0-1.667 2.5 2.5 0 0 0-2.5 2.5v.625a.21.21 0 0 1-.208.208H4.917a1.667 1.667 0 0 0-1.725 1.55L2 20.374a1.667 1.667 0 0 0 1.725 1.625H20.39a1.617 1.617 0 0 0 1.608-1.667zM12 4.5a.833.833 0 0 1 .833-.833h2.5a.833.833 0 0 1 .833.833v.625a.21.21 0 0 1-.208.208h-3.75A.21.21 0 0 1 12 5.125zM4.133 20.332a.416.416 0 0 1-.416-.45L4.883 7.383A.417.417 0 0 1 5.333 7h2.15a.417.417 0 0 1 .417.391l.691 12.5a.4.4 0 0 1-.416.433z"
  })));
};
export default SvgShopping;